import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { EnergyStarItem } from '../model/energy-star-item.model';
import {
  EnergyStarAccount,
  EnergyStarAccountsResponse,
  CreateEnergyStarAccountRequest,
  UpdateEnergyStarAccountRequest,
} from '../model/energy-star-account.model';

export interface EnergyStarSubmissionRequest {
  facilityName: string;
  propertyCategory: string;
  primaryFunction: string;
  facilityGrossArea: number;
  yearBuilt: number;
  occupancyPercentage: number;
}

@Injectable({
  providedIn: 'root',
})
export class EnergyStarSubmissionService {
  private readonly baseUrl = environment.apiBaseUrl;
  private readonly adminBaseUrl = environment.apiBaseAdminUrl;

  constructor(private http: HttpClient) {}

  submitEnergyStarApplication(facilityId: string, submission: EnergyStarSubmissionRequest): Observable<EnergyStarItem> {
    return this.http.post<EnergyStarItem>(`${this.baseUrl}/facilities/${facilityId}/energyStarSubmission`, submission);
  }

  getEnergyStarAccounts(): Observable<EnergyStarAccountsResponse> {
    return this.http.get<EnergyStarAccountsResponse>(`${this.adminBaseUrl}/energyStarAccounts`);
  }

  createEnergyStarAccount(request: CreateEnergyStarAccountRequest): Observable<EnergyStarAccount> {
    return this.http.post<EnergyStarAccount>(`${this.adminBaseUrl}/energyStarAccounts`, request);
  }

  updateEnergyStarAccount(id: number, request: UpdateEnergyStarAccountRequest): Observable<EnergyStarAccount> {
    return this.http.put<EnergyStarAccount>(`${this.adminBaseUrl}/energyStarAccounts/${id}`, request);
  }
}
